import React from "react";
import SVG from "react-inlinesvg";
import styled from "styled-components/macro";

const StyledPuppets = styled.div`
  height: 50px;
  width: 320px;
`;

const StyledGenericPuppet = styled.div`
  width: 60px;
  float: right;
  position: relative;
  margin-top: -14px;
  margin-left: 10px;
`;

const Puppet = ({ errorMessage }) => (
  <StyledPuppets>
    <StyledGenericPuppet>
      <SVG src="/assets/brainstorm/generic-puppet.svg" />
    </StyledGenericPuppet>
  </StyledPuppets>
);

export default Puppet;
